import React from 'react';
import styled, { css } from 'styled-components';

import { AlexaText } from '@amzn/monera-app-alexa-shared-libs';

import { StyledCarouselButtonProps, TopSkillsContainerProps } from './types';

const setBorderRadius = (props: StyledCarouselButtonProps) =>
  props.isBorderLeft
    ? css`
        border-radius: 3px 0px 0px 3px;
      `
    : css`
        border-radius: 0px 3px 3px 0px;
      `;

const setHoverShadow = (props: StyledCarouselButtonProps) =>
  props.isBorderLeft
    ? css`
        box-shadow: -2px 0 6px rgba(136, 136, 136, 0.8);
      `
    : css`
        box-shadow: 2px 0 6px rgba(136, 136, 136, 0.8);
      `;

const setJustifyContent = (props: StyledCarouselButtonProps) =>
  props.isBorderLeft
    ? css`
        justify-content: flex-end;
      `
    : css`
        justify-content: center;
      `;

const setBoxShadow = (props: StyledCarouselButtonProps) =>
  props.isBorderLeft
    ? css`
        box-shadow: -2px 0 6px rgba(136, 136, 136, 0.4);
      `
    : css`
        box-shadow: 2px 0 6px rgba(136, 136, 136, 0.4);
      `;

export const StyledText = styled((props) => <AlexaText {...props} />)`
  max-width: 92vw;
  min-width: 172px;
  padding: 0 0 4px 0;
`;

export const TopSkillsContainer = styled.div<TopSkillsContainerProps>`
  ${(props) => (props.isMobile ? '' : 'min-width: 780px')};
  width: 100%;
  max-width: 1260px;
  border-top: 1px solid #e7e7e7;
  padding: 14px 0px 0px 0px;
  margin-bottom: 20px;
`;

export const StyledCarouselButton = styled.button`
  height: 60px;
  width: 34px;
  display: flex;
  align-items: center;
  ${setJustifyContent};
  cursor: pointer;
  background-color: #ffffff;
  border: none;
  padding: 0px 5px;
  ${setBoxShadow};
  ${setBorderRadius};
  &:hover {
    ${setHoverShadow}
  }
`;
